/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
/* cspell: ignore languagedetector, Lngs */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .use(Backend)
    .init({
        supportedLngs: ["en", "fr"],
        fallbackLng: "en",
        ns: ["HapComponents", "HierarchicalSettings"],
        defaultNS: "HierarchicalSettings",
        backend: { loadPath: "locales/{{lng}}/{{ns}}.json", crossDomain: true },
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
